import AScene from "./AScene.js";

export default class ASpine
{
    /**
     * @param {AScene} scene 
     * @param {(TrackEntry)=>void} onComplete 
     */
    constructor(scene, x, y, key, animation, loop, onComplete)
    {
        this.scene = scene;
        this.spine = this.scene.add.spine(x, y, key, animation, loop);

        if(onComplete) {
            this.spine.state.addListener({
                complete: (trackEntry)=>{ onComplete(trackEntry);}
            });
        }
        
        this.spine.preUpdate = (time, delta)=>{this.preUpdate(time, delta);};
    }

    /**
    * @param {(TrackEntry, TrackEvent)=>void} onCalled 
    */
    addListener(eventName, onCalled)
    {
        //loop through all listeners to check if one of the same type already exists
        for(let n = this.spine.state.listeners.length-1; n >= 0; n--){
            let props = Object.keys(this.spine.state.listeners[n]);

            //if a listener exists of the same type, exit out.
            if(props[0] === eventName) return;
            else {
                //otherwise add the listener
                if(eventName === "event"){
                    this.spine.state.addListener({
                        event: (track, event)=>{ 
                            if(event.data.name == eventName) onCalled(track, event); 
                        }
                    });
                }
                else if(eventName === "complete"){
                    this.spine.state.addListener({
                        complete: (trackEntry)=>{ onCalled(trackEntry);}
                    });
                }
            }
        }
    }

    removeListenerByName(eventName)
    {
        for(let n = this.spine.state.listeners.length-1; n >= 0; n--){
            let props = Object.keys(this.spine.state.listeners[n]);
            if(props.length === 1 && props[0] === eventName){
                this.spine.state.listeners.splice(n, 1);
            }
        }
    }

    setSkin(skinName)
    {
        if(!this.spine.skinNulled)
        {
            this.spine.setSkin(null);
            this.spine.skinNulled = true;
        }
        
        this.spine.setSkinByName(skinName);
    }

    setAttachment(slotName, attachmentName) 
    {
        this.spine.skeleton.setAttachment(slotName, attachmentName);
    }

    getAttachments()
    {
        return this.character.skeleton.skin.attachments;
    }

    play(animationName, loop = false)
    {
        this.spine.play(animationName, loop);
    }

    playTrack(animationName, loop = false, track = 0)
    {
        this.spine.state.setAnimation(track, animationName, loop);
    }

    getAnimations()
    {
        return this.spine.getAnimationList();
    }
    
    getSlots()
    {
        return this.spine.skeleton.slots;
    }

    getSlot(slotName)
    {
        return this.spine.skeleton.findSlot(slotName);
    }

    getBone(boneName)
    {
        return this.spine.findBone(boneName);
    }

    setDefaultMix(duration)
    {
        this.spine.stateData.defaultMix = duration;
    }

    setMixByName(fromName, toName, duration)
    {
        this.spine.setMix(fromName, toName, duration);
    }

    clearTracks()
    {
        this.spine.state.clearTracks();
    }

    getBounds()
    {
        return this.spine.plugin.getBounds(this.spine.skeleton);
    }

    preUpdate(time, delta)
    {
        let skeleton = this.spine.skeleton;
        skeleton.flipX = this.spine.flipX;
        skeleton.flipY = this.spine.flipY;

        this.spine.state.update((delta / 1000) * this.spine.timeScale);
        this.spine.state.apply(skeleton);
        this.spine.emit('spine.update', skeleton);

        skeleton.updateWorldTransform();
    }

    setInteractive(xOffset, yOffset, width, height, onDown, debug)
    {
        this.scene.addDelay(0, ()=>
        {
            let pos = { x: this.spine.x, y: this.spine.y };
            let parent = this.spine.parentContainer;

            while (parent != null) {
                pos.x += parent.x;
                pos.y += parent.y;
                parent = parent.parentContainer;
            }

            let rect = new Phaser.Geom.Rectangle(pos.x + xOffset, pos.y + yOffset, width, height);
            this.hitBox = this.scene.createRect(rect.x - (width * .5), rect.y - (height * .5), rect.width, rect.height, 0xff0000);
            this.hitBox.alpha = debug ? .00001 : 0;


            this.hitBox.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
            this.hitBox.on("pointerdown", () => {
                onDown();
            });
        });
    }

    disableInteractive()
    {
        if(this.hitBox) this.hitBox.disableInteractive();
    }
}